<template>
  <div>
    <div class="blocks">
      <div class="top">实时报警</div>
      <div class="blossomVideo">
        <el-table
          :data="tableData"
          style="width: 316px;background:#091536;font-size:12px;overflow: hidden"
          height="144"
          border
          :row-style="tableRowStyle"
          :header-cell-style="{background:'#c3b18b',color:'#f3ece4'}"
        >
          <el-table-column
            align="center"
            prop="BreakDownDescription"
            width="78"
            label="报警类型"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span
                v-if="scope.row.Count=='1'"
                style="color: #BA1923"
              >{{scope.row.BreakDownDescription}}</span>
              <span
                v-else-if="scope.row.Count=='2'"
                style="color:#F2AA43"
              >{{scope.row.BreakDownDescription}}</span>
              <span v-else>{{scope.row.BreakDownDescription}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="BreakDownMessage"
            width="79"
            label="报警位置"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span
                v-if="scope.row.Count=='1'"
                style="color: #BA1923"
              >{{scope.row.BreakDownMessage}}</span>
              <span
                v-else-if="scope.row.Count=='2'"
                style="color:#F2AA43"
              >{{scope.row.BreakDownMessage}}</span>
              <span v-else>{{scope.row.BreakDownMessage}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="BreakDownType"
            width="79"
            label="报警描述"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span v-if="scope.row.Count=='1'" style="color: #BA1923">{{scope.row.BreakDownType}}</span>
              <span
                v-else-if="scope.row.Count=='2'"
                style="color:#F2AA43"
              >{{scope.row.BreakDownType}}</span>
              <span v-else>{{scope.row.BreakDownType}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="CreateTime"
            width="79"
            label="报警时间"
            :show-overflow-tooltip="true"
          >
            <template v-slot="scope">
              <span
                v-if="scope.row.Count=='1'"
                style="color: #BA1923"
              >{{scope.row.CreateTime | timeFilter('-')}}</span>
              <span
                v-else-if="scope.row.Count=='2'"
                style="color:#F2AA43"
              >{{scope.row.CreateTime | timeFilter('-')}}</span>
              <span v-else>{{scope.row.CreateTime | timeFilter('-')}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="bottom">
          <nav>
            <ul class="pagination">
              <li :class="{'disabled': current == 1}">
                <a href="javascript:;" @click="setCurrent(current - 1)" style="font-size: 14px;">◀</a>
              </li>
              <li v-if="size!='mini'" :class="{'disabled': current == 1}">
                <a href="javascript:;" @click="setCurrent(1)">首页</a>
              </li>
              <li
                v-for="(p , index) in grouplist"
                :class="{'active': current == p.val}"
                :key="index"
              >
                <a href="javascript:;" @click="setCurrent(p.val)" v-text="p.text"></a>
              </li>
              <li v-if="size!='mini'" :class="{'disabled': current == page}">
                <a href="javascript:;" @click="setCurrent(page)">尾页</a>
              </li>
              <li :class="{'disabled': current == page}">
                <a href="javascript:;" @click="setCurrent(current + 1)" style="font-size: 14px;">▶</a>
              </li>
              <li>
                <span>
                  共
                  <span v-text="page"></span>页
                </span>
              </li>
              <li>
                <span>
                  到第
                  <input class="page-input" type="text" v-model="switchPage" style="border:none;" />页
                </span>
              </li>
              <li>
                <a href="javascript:;" @click="setCurrent(switchPage)">确定</a>
              </li>
            </ul>
          </nav>
        </div> -->
         <div class="bottomfenye">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page.sync="pageIndex"
            background
            :pager-count="5"
            small
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//这是表格组件
// import pagetion from "../widgets/pegination";
export default {
  name: "echarts02",
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [
          {
            BreakDownDescription: "#1号堆垛机",
            BreakDownMessage: "超时",
            BreakDownType: "设备故障",
            Count: 1,
            CreateTime: "2019-04-08T03:47:20.394"
          },
          {
            BreakDownDescription: "1113提升机",
            BreakDownMessage: "超高限",
            BreakDownType: "设备故障",
            Count: 2,
            CreateTime: "2019-04-08T03:47:20.394"
          },
          {
            BreakDownDescription: "1074夹抱机",
            BreakDownMessage: "气压低",
            BreakDownType: "设备故障",
            Count: 3,
            CreateTime: "2019-04-08T03:47:20.394"
          },
          {
            BreakDownDescription: "1077提升机",
            BreakDownMessage: "空开故障",
            BreakDownType: "设备故障",
            Count: 1,
            CreateTime: "2019-04-08T03:47:20.394"
          }
        ];
      }
    },
    total: {
      // 数据总条数
      type: Number,
      default: 120
    },
    // size: {
    //   //尺寸
    //   type: String,
    //   default: "large"
    // },
    // display: {
    //   // 每页显示条数
    //   type: Number,
    //   default: 10
    // },
    // currentPage: {
    //   // 当前页码
    //   type: Number,
    //   default: 1
    // },
    // pagegroup: {
    //   // 分页条数，偶数有bug
    //   type: Number,
    //   default: 3,
    //   coerce: function(v) {
    //     v = v > 0 ? v : 5;
    //     return v % 2 === 1 ? v : v + 1;
    //   }
    // }
  },
  data() {
    return {
      totalCount: 0,
      pageIndex: 1,
      pageSize: 4,
      // current: this.currentPage,
      // switchPage: ""
    };
  },
  created() {},
  computed: {
    // page: function() {
    //   // 总页数
    //   return Math.ceil(this.total / this.display);
    // },
    // grouplist: function() {
    //   // 获取分页页码
    //   var len = this.page,
    //     temp = [],
    //     list = [],
    //     count = Math.floor(this.pagegroup / 2),
    //     center = this.current;
    //   if (len <= this.pagegroup) {
    //     while (len--) {
    //       temp.push({ text: this.page - len, val: this.page - len });
    //     }
    //     return temp;
    //   }
    //   while (len--) {
    //     temp.push(this.page - len);
    //   }
    //   var idx = temp.indexOf(center);
    //   idx < count && (center = center + count - idx);
    //   this.current > this.page - count && (center = this.page - count);
    //   temp = temp.splice(center - count - 1, this.pagegroup);
    //   do {
    //     var t = temp.shift();
    //     list.push({
    //       text: t,
    //       val: t
    //     });
    //   } while (temp.length);
    //   if (this.page > this.pagegroup && this.size != "mini") {
    //     this.current > count + 1 &&
    //       list.unshift({ text: "...", val: list[0].val - 1 });
    //     this.current < this.page - count &&
    //       list.push({ text: "...", val: list[list.length - 1].val + 1 });
    //   }
    //   return list;
    // }
  },
  filters: {
    timeFilter: function(input) {
      const date = new Date(input);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      // const hour = date.getHours()
      // const minus = date.getMinutes()
      // const second = date.getSeconds()
      const hour =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      const minus =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const second =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      // 过滤器必须要有返回值
      // return ` ${hour}:${minus}:${second}`
      return ` ${hour}:${minus}:${second}`;
    }
  },
  methods: {
    tableRowStyle() {
      return "background-color:#091536;color: #fff;height:28px";
    },
    // 修改table header的背景色
    tableHeaderColor({ rowIndex }) {
      //   if (rowIndex === 0) {
      return "background-color: #162A61;color: #fff;border:none";
      //   }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      //   this.pagenum = val;
      //把当前页传递给父组件
      this.$emit("watchpage02", val);
    },
    // pageChange(pageIndex) {
    //   console.log("pageIndex", pageIndex);
    //   this.pageIndex = pageIndex;
    //   this.getItemList();
    // },
    // setCurrent: function(idx) {
    //   idx = parseInt(idx);
    //   if (this.current != idx && idx > 0 && idx < this.page + 1) {
    //     this.current = idx;
    //     this.$emit("pagechange", this.current);
    //   }
    // }
  },
  components: {
    // pagetion
  }
};
</script>
<style  scoped>
.blocks {
  width: 318px;
  height: 222px;
  background: url("../../assets/img/title-bg.png") no-repeat;
  position: relative;
  /* background: #fff; */
  border-radius: 8px;
}
.top {
  position: absolute;
  left: 85px;
  top: -12px;
  width: 150px;
  height: 32px;
  color: #796423;
  text-align: center;
  line-height: 32px;
  background-image: linear-gradient(to right,#f8f1d5, #ffffff);
  border-radius: 8px;
}
.blossomVideo {
  width: 316px;
  height: 180px;
  font-size: 12px;
  position: absolute;
  top: 32px;
  left: 1px;
  border-radius: 6px;
}
.blossomVideo >>> .el-table th {
  padding: 4px 0 !important;
  font-size: 14px;
}
.blossomVideo >>> .el-table--border {
  border-color: #1f3169;
}
.blossomVideo >>> .el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
  border-color: #1f3169;
}
.blossomVideo >>> .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #091536 !important;
}
.blossomVideo >>> .el-table--border {
  border: none;
}
.blossomVideo .el-table::before {
  background-color: #1f3169;
}
.blossomVideo >>> .el-table--border::after,
.el-table--group::after {
  background-color: #1f3169;
  /* width: 0px */
}
.blossomVideo >>> .el-table td,
.el-table th {
  padding: 0;
  font-size: 12px;
}
.bottom {
  height: 36px;
  width: 100%;
  margin-top: 5px;
}
.btn {
  width: 318px;
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
}
.bottomfenye {
  width: 100%;
  height: 40px;
}
.bottomfenye >>> .el-input__inner {
  color: #70a593;
  width: 30px;
  background: #fafffe !important
}
.bottomfenye .el-pagination .is-background .el-pager li:not(.disabled).active {
  color: #1111;
  background-color: #FD7A3A !important
}

/* .pagination {
  width: 100%;
  text-align: center;
}
.pagination li {
  display: inline-block;
  height: 30px;
  border-radius: 5px;
  color: #666;
  vertical-align: middle;
}
.pagination li:hover a {
  color: #e7e7e7;
}

.pagination li a {
  display: block;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
  border-radius: 5px;
  text-decoration: none;
  padding: 0 8px;
}
.pagination li .page-input {
  width: 42px;
}
.pagination .active a {
  color: #e7e7e7;
}
.pagination li {
  height: auto;
}
.pagination li a {
  font-size: 12px;
  color: #e7e7e7;
  background-image: url("../../assets/imgs/button.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 3px 5px;
}
.pagination li span {
  font-size: 12px;
  line-height: 36px;
  color: #e7e7e7;
}
.pagination li .page-input {
  color: #fff;
  font-size: 12px;
  background-image: url("../../assets/imgs/button.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: transparent;
  padding: 9px 5px;
  width: 28px;
  text-align: center;
}
.pagination .active a {
  color: #fff;
  background-image: url("../../assets/imgs/button.png");
}
.pagination .arrow-left {
  font-size: 0;
  line-height: 0;
  border-width: 10px;
  border-color: red;
  border-left-width: 0;
  border-style: dashed;
  border-right-style: solid;
  border-top-color: transparent;
  border-bottom-color: transparent;
} */
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts02.vue